import React from 'react';
import {
    Grid,
    Paper,
    Typography,
    Divider,
} from '@material-ui/core';
import useStyles from '../styles/styles';
import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';

const DashMain = props => {
    const classes = useStyles();
    const { loading, error, data } = useQuery(gql`
        {
            countLoanRequests
        }
    `);

    const LeadCountStat = props => {
        if (loading) return null
        if (error) return <p>Error</p>
        return (
            <>
                <Typography variant="h6">Lead Count</Typography>
                <Divider />
                <Typography variant="h3">{data.countLoanRequests}</Typography>
            </>
        )
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
                <Paper className={classes.paper}>
                    <LeadCountStat />
                </Paper>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <Paper className={classes.paper}>

                </Paper>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
                <Paper className={classes.paper}>

                </Paper>
            </Grid>
        </Grid>
    )
}

export default DashMain;
